import React from 'react';
import Icon404 from '../images/404.svg';
import { Flex } from './Flex';
import { Paragraph, Title } from './Text';

const Page404 = () => {

    return (
        <Flex direction="column" height="100%" align="center" justify="center">
            <img src={Icon404} alt="404" style={{ marginBottom: "22px" }} />
            <Title h3 color="#3E6FC1" margin={{ bottom: "10px" }}>Sorry, this page isn't available</Title>
            <Paragraph size="16px" style={{ width: "434px", textAlign: "center" }}>The link you followed may be broken, or the page may have been removed. Go back to <a href="/#/">Main Page</a>.</Paragraph>
        </Flex>
    )
}

export { Page404 };
